import Axios from '@/components/api/axios.js'

export default {
	//************************************************************************************************单位基本信息
	/**
	 * 查询用户所属的单位以及下属单位树
	 */
	getUnitTree: (success, failure) => {
		Axios.post('/unit/getUnitTree.do', {}, success, failure);
	},
	/**
	 * 查询用户所属的单位以及区域
	 */
	 getAreaTree: (success, failure) => {
		Axios.get('/area/findArea', {}, success, failure);
	},
	/**
	 * 保存单位
	 * @param {String} id 单位id 不传默认添加否则更新
	 * @param {String} type 类型   0企业 /1组织架构
	 * @param {String} parentId 上级ID
	 * @param {String} unitCode 编号
	 * @param {String} name 单位名称
	 * @param {String} fullName 全称
	 * @param {String} address 地址
	 * @param {String} leader 负责人
	 * @param {String} phoneNum 联系方式
	 * @param {String} memo 备注
	 * @param {int} sort 排序
	 * @param {int} capacity 变压器总容量
	 * @param {String} inletWire 进线来源
	 * @param {String} location 地理坐标
	 * @param {String} joinTime 接入时间
	 * @param {String} expirationTime 合同到期时间
	 * @param {String} roomCount 电房数量
	 * @param {String} transformerCount 变压器数量
	 * @param {int} loadCapacity 负荷容量
	 * @param {String} unitArea 单位面积
	 * @param {String} unitPeopleNumber 单位人数 
	 * @param {String} energIndex 能耗指标
	 * @param {String} energySavingRatio 目标节能比例
	 */
	saveUnit: (id, type, parentId, unitCode, name, fullName, address, leader, phoneNum, memo, sort, capacity, inletWire, location, joinTime,
		expirationTime, roomCount, transformerCount, loadCapacity,unitArea,unitPeopleNumber,energIndex,energySavingRatio, success, failure) => {
		Axios.post('/unit/saveUnit.do', {
				id,
				type,
				parentId,
				unitCode,
				name,
				fullName,
				address,
				leader,
				phoneNum,
				memo,
				sort,
				capacity,
				inletWire,
				location,
				joinTime,
				expirationTime,
				roomCount,
				transformerCount,
				loadCapacity,
				unitArea,
				unitPeopleNumber,
				energIndex,
				energySavingRatio,
			},
			success, failure);
	},
	/**
	 * 删除单位
	 * @param {String} id 单位id
	 */
	delUnit: (id, success, failure) => {
		Axios.post('/unit/delUnit.do', {
				id
			},
			success, failure);
	},
	/**
	 * 获取指定单位信息
	 * @param {String} unitId 单位id
	 */
	getUnit: (unitId, success, failure) => {
		Axios.post('/unit/getUnit.do', {
			unitId
		}, success, failure);
	},
	/**
	 * 获取指定单位电表扣费日期
	 * @param {String} unitId 单位id
	 */
	getUnitDeductionFeeDay: (unitId, success, failure) => {
		Axios.post('/unit/getUnitDeductionFeeDay.do', {
			unitId
		}, success, failure);
	},
	//************************************************************************************************单位补充缺陷信息
	/**
	 * 保存缺陷信息
	 * @param {String} unitId 用户id
	 * @param {Date} safeRunTime 安全运行时间，yyyy-MM-dd HH:mm:ss,默认初始值是单位接入时间，管理员可修改
	 * @param {int} processedErrorCount 已解决缺陷数
	 * @param {int} findErrorCount 发现缺陷数
	 * @param {String} texts 备注信息
	 */
	saveUnitInfo: (unitId, safeRunTime, processedErrorCount, findErrorCount, texts, checkPlan, checkCompleted, success, failure) => {
		Axios.post('/unit/saveUnitInfo.do', {
				unitId,
				safeRunTime,
				processedErrorCount,
				findErrorCount,
				texts,
				checkCompleted,
				checkPlan
			},
			success, failure);
	},
	/**
	 * 获取缺陷信息
	 * @param {String} id 单位id
	 */
	getUnitInfo: (id, success, failure) => {
		Axios.post('/unit/getUnitInfo.do', {
				id
			},
			success, failure);
	},
	/**
	 * 删除单位补充信息
	 * @param {String} id 单位id
	 */
	deleteUnitInfo: (id, success, failure) => {
		Axios.post('/unit/deleteUnitInfo.do', {
				id
			},
			success, failure);
	},
	/**
	 * 清零,重置安全运行时间
	 * @param {String} id 单位id
	 */
	resetSafeRunTime: (id, success, failure) => {
		Axios.post('/unit/resetSafeRunTime.do', {
				id
			},
			success, failure);
	},
	//************************************************************************************************单位补充行业信息
	/**
	 * 获取所有的行业信息
	 */
	getAllIndustry: (success, failure) => {
		Axios.post('/industry/getAllIndustry.do', {},
			success, failure);
	},
	/**
	 * 分页获取行业
	 */
	getIndustryLimit: (pageIndex, pageSize, beginTime, endTime, name, success, failure) => {
		Axios.post('/industry/getIndustryLimit.do', {
				pageIndex,
				pageSize,
				beginTime,
				endTime,
				name,
			},
			success, failure);
	},
	/**
	 *获取指定单位的行业信息
	 */
	getIndustryByUnitId: (unitId, success, failure) => {
		Axios.post('/industry/getIndustryByUnitId.do', {
				unitId,
			},
			success, failure);
	},
	/**
	 *添加或更新指定行业信息
	 */
	saveIndustry: (pkid, name, memo, success, failure) => {
		Axios.post('/industry/saveIndustry.do', {
				pkid,
				name,
				memo,
			},
			success, failure);
	},
	/**
	 *删除指定行业信息
	 */
	deleteIndustry: (pkid, success, failure) => {
		Axios.post('/industry/deleteIndustry.do', {
				pkid,
			},
			success, failure);
	},
	/**
	 *绑定指定单位与行业信息
	 */
	bindUnitAndIndustry: (unitId, pkid, success, failure) => {
		Axios.post('/industry/bindUnitAndIndustry.do', {
				unitId,
				pkid,
			},
			success, failure);
	},
	/**
	 *解绑指定单位的所有行业关联关系
	 */
	unbindByUnitId: (unitId, success, failure) => {
		Axios.post('/industry/unbindByUnitId.do', {
				unitId,
			},
			success, failure);
	},
	/**
	 *解绑指定行业的所有单位关联关系
	 */
	unbindByPkid: (pkid, success, failure) => {
		Axios.post('/industry/unbindByPkid.do', {
				pkid,
			},
			success, failure);
	},
	//************************************************************************************************单位看板统计信息
	/**
	 *获取单位下用户数、设备数、监测点数
	 */
	getKanbanCountInfo: (unitId, success, failure) => {
		Axios.post('/unit/getKanbanCountInfo.do', {
				unitId,
			},
			success, failure);
	},
	/**
	 *获取子单位
	 */
	getLocalUnits: (unitId, success, failure) => {
		Axios.post('/unit/getLocalUnits.do', {
				unitId,
			},
			success, failure);
	},
	/**
	 * 获取当天前十温度
	 * @param unitId
	 * @param dateTime
	 * @param listSize
	 * @param success
	 * @param failure
	 */
	getUnitTemperatureRanking:(unitId,time,listSize,success,failure) => {
		Axios.post('/unit/getUnitTemperatureRanking.do',{
			unitId,
			time,
			listSize
		},success,failure);
	}
}